module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel md-scrollbar md-theme-default",
    attrs: {
      "id": "cost-settings"
    }
  }, [_c('md-content', {
    staticClass: "full-height md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('cost-menu'), (Object.keys(_vm.properties).length) ? _c('form', {
    staticClass: "md-theme-default cost-settings-form",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('div', {
    staticClass: "md-layout md-gutter main-cost-layout"
  }, [_c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-50"
  }, [_c('toggle-card', {
    staticClass: "cost-card",
    attrs: {
      "visibility": true,
      "heading": "Цена перевозки"
    }
  }, [_c('module-property', {
    key: _vm.properties['calculation_type_coefficient'].id,
    attrs: {
      "property": _vm.properties['calculation_type_coefficient'],
      "module": "cost"
    }
  }), _c('module-property', {
    key: _vm.properties['default_price_by_weight'].id,
    attrs: {
      "property": _vm.properties['default_price_by_weight'],
      "module": "cost"
    }
  }), _c('module-property', {
    key: _vm.properties['default_price_by_volume'].id,
    attrs: {
      "property": _vm.properties['default_price_by_volume'],
      "module": "cost"
    }
  }), _c('module-property', {
    key: _vm.properties['ttn_markup'].id,
    attrs: {
      "property": _vm.properties['ttn_markup'],
      "module": "cost"
    }
  }), _c('module-property', {
    key: _vm.properties['agent_markup'].id,
    attrs: {
      "property": _vm.properties['agent_markup'],
      "module": "cost"
    }
  })], 1)], 1), _c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-50"
  }, [_c('toggle-card', {
    staticClass: "cost-card",
    attrs: {
      "visibility": true,
      "heading": "Хранение груза"
    }
  }, [_c('module-property', {
    key: _vm.properties['freight_storage_type'].id,
    attrs: {
      "property": _vm.properties['freight_storage_type'],
      "module": "cost"
    }
  }), _c('module-property', {
    key: _vm.properties['freight_storage_price'].id,
    attrs: {
      "property": _vm.properties['freight_storage_price'],
      "module": "cost"
    }
  }), _c('module-property', {
    key: _vm.properties['freight_storage_free_period'].id,
    attrs: {
      "property": _vm.properties['freight_storage_free_period'],
      "module": "cost"
    }
  }), _c('module-property', {
    key: _vm.properties['freight_storage_free_period_forwarding'].id,
    attrs: {
      "property": _vm.properties['freight_storage_free_period_forwarding'],
      "module": "cost"
    }
  })], 1)], 1), _c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-50"
  }, [_c('toggle-card', {
    staticClass: "cost-card",
    attrs: {
      "visibility": true,
      "heading": "Настройки веса"
    }
  }, [_c('module-property', {
    key: _vm.properties['min_weight'].id,
    attrs: {
      "property": _vm.properties['min_weight'],
      "module": "cost"
    }
  }), _c('module-property', {
    key: _vm.properties['min_volume'].id,
    attrs: {
      "property": _vm.properties['min_volume'],
      "module": "cost"
    }
  })], 1)], 1), _c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-50"
  }, [_c('toggle-card', {
    staticClass: "cost-card",
    attrs: {
      "visibility": true,
      "heading": "Обрешётка"
    }
  }, [_c('module-property', {
    key: _vm.properties['doom_markup'].id,
    attrs: {
      "property": _vm.properties['doom_markup'],
      "module": "cost"
    }
  })], 1)], 1), _c('div', {
    staticClass: "md-layout-item md-alignment-top-left md-size-50"
  }, [_c('toggle-card', {
    staticClass: "cost-card",
    attrs: {
      "visibility": true,
      "heading": "Наименовая услуг"
    }
  }, [_c('module-property', {
    key: _vm.properties['forwarding_from_label'].id,
    attrs: {
      "property": _vm.properties['forwarding_from_label'],
      "module": "cost"
    }
  }), _c('module-property', {
    key: _vm.properties['forwarding_to_label'].id,
    attrs: {
      "property": _vm.properties['forwarding_to_label'],
      "module": "cost"
    }
  }), _c('module-property', {
    key: _vm.properties['oversize_label'].id,
    attrs: {
      "property": _vm.properties['oversize_label'],
      "module": "cost"
    }
  }), _c('module-property', {
    key: _vm.properties['storage_label'].id,
    attrs: {
      "property": _vm.properties['storage_label'],
      "module": "cost"
    }
  }), _c('module-property', {
    key: _vm.properties['ttn_label'].id,
    attrs: {
      "property": _vm.properties['ttn_label'],
      "module": "cost"
    }
  })], 1)], 1)])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11d9a6c2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/OtherSettings.vue
// module id = 1040
// module chunks = 0